import type React from 'react'
import type { JSX } from 'react'

import { COLOR, FIXED_INDENTS, LAYOUT } from 'vars/index'
import { FooterHeightAdjustSC, FooterSC } from './Footer.styled'

export interface IFooter {
  children?: React.ReactNode
  background?: COLOR
  paddings?: Array<FIXED_INDENTS | LAYOUT>
  adjustHeight?: number
}

export const Footer = ({
  background = COLOR.BACKGROUND_PROGRAM_CARD,
  paddings = [
    FIXED_INDENTS.INDENT_60,
    LAYOUT.HorizontalPaddings,
    FIXED_INDENTS.INDENT_70,
  ],
  adjustHeight,
  children,
}: IFooter): JSX.Element | null => {
  return (
    <FooterSC background={background} paddings={paddings}>
      <>
        {children}
        <FooterHeightAdjustSC height={adjustHeight} />
      </>
    </FooterSC>
  )
}
